import React, { useState,useEffect } from "react";
import DatalistInput from 'react-datalist-input';
import 'react-datalist-input/dist/styles.css';
import Iconos from "../iconos/iconos";
import Modal from "../modal";
import { useModal } from "../../hooks/useModal";
import './uploadfile.css'
import { URL, GETVESSELITINERARY, SAVEUPDATEREFERENCE,URL_CONSULTAR_SUCURSALES,URL_LOGIN_SUCURSALES,USER,PSW, URL_IPM, GetCalathusVesselVoyage ,SAVEUPDATEDOCUMENT, SEARCHCOMPANY, GETREFERENCEBYID, GETDOCUMENTCATALOG, SENDREFERENCE } from "../paths";
import { fetchData } from "../../hooks/fetch/const_fetch"; 
import { getUserID, getUserName, getintUserEntityId,getIntUserEntityTypeId,getUserBillingIdentifier, getUserFiscalIdentifier } from "../datainfo/dto";

import MostrarPdf from "../mostrar_pdf/MostrarPdf";
import { Mensaje } from "../Message/message";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Loader from "../loader/loader";

import Entidad_Sucursales from "./Entidad_Sucursales";

const UploadFile=({referenciaid = 0, setReferenciaId, strreferencia,agrgandodocumento,setAgregandoDocumentos, ConsultarDocumentosUsuario, modo, setModo, isOpenSubirDocumento, OpenSubirDocumento, closeModal})=>{
    
    const [tabIndex, setTabIndex]   = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [documentos,setDocumentos] = useState([]); 
   
    const [intInvDockTypeId,setIntInvDockTypeId] = useState(0); //id de tipo de entidad fact-muellaje
    const [intInvDockId,setIntInvDockId] = useState(0); // id de entidad fact- muellaje
    const [intInvDockAddressId,setIntInvDockAddressId] = useState(0); // id de sucursal fact- muellaje
    const [strInvDockFiscalId,setStrInvDockFiscalId] = useState(""); //RFC entidad fact- muellaje
    const [strInvDockZipCode,setStrInvDockZipCode] = useState(""); //CP de sucursal entidad fact- muellaje,
    
    const [intInvPBIPTypeId,setIntInvPBIPTypeId] = useState(0); //id de tipo de entidad fact- PBIP
    const [intInvPBIPId,setIntInvPBIPId] = useState(0); //id de entidad fact:- PBIP
    const [intInvPBIPAddressId,setIntInvPBIPAddressId] = useState(0); // id direccion muellaje
    const [strInvPBIPFiscalId,setStrInvPBIPFiscalId] = useState(""); //RFC entidad fact- PBIP
    const [strInvPBIPZipCode, setStrInvPBIPZipCode] = useState(""); //CP de sucursal entidad fact- PBIP

    const [pbipi_sucursales,setPbipSucursales] = useState([]);
    const [muellaje_sucursales,setMuellajeSucursales] = useState([]); 
    
    const [intCusDocStatusId,setIntCusDocStatusId] = useState(0); 
    const [estatus,setEstatus] = useState(""); 

    const [listatipodocumento,setListaTipoDocumento] = useState([]); 
    const [referencia,setReferencia] = useState("");
    const [validareferencia,setValidaReferencia] = useState("");
    const handleReferencia=(strref)=>{
            if(strref.trim().length > 5 && strref.trim().length <= 45){ 
                setReferencia(strref.toUpperCase());
                setValidaReferencia(" is-valid ")
            }else{ 
                setReferencia(strref.toUpperCase());
                setValidaReferencia(" is-invalid ")
            }
    }
    /************************************************************************************************/
    const [isCheckedPBIP, setIsCheckedPBIP] = useState(false);
    const [isCheckedMUELLAJE, setIsCheckedMUELLAJE] = useState(false);

    const handleCheckBoxChange = (event,code) => {
        if(code===1){
            setIsCheckedPBIP(event.target.checked);
            if(!event.target.checked){
                limpiarPbip();
            }
        }else{
            setIsCheckedMUELLAJE(event.target.checked);
            if(!event.target.checked){
                limpiarMuellaje();
            }
        }
    };
    /*************************************************************************************************/
    const [listaentidades, setListaEntidades] = useState([]); 
    const [listaentidadesmuellaje, setListaEntidadesMuellaje] = useState([]); 
    
    const [entidadpbipid,setEntidadPbipId] = useState();
    const [entidadpbiptypeid,setEntidadPbipTypeId] = useState();
    const [validaentidadpbip, setValidaEntidadPBIP] =useState("");
    const [nombreentidadpbipid,setNombreEntidadPbipId] = useState("");
    const [readOnlyentidadpbipid,setReadOnlyEntidadPbipId] = useState();

    const [entidadmuellajeid,setEntidadMuellajeId] = useState();
    const [entidadmuellajetypeid,setEntidadMuellajeTypeId] = useState();
    const [validaentidadmuellaje, setValidaEntidadMuellaje] =useState("");
    const [nombreentidadmuellaje,setNombreEntidadMuellaje] = useState("");
    const [readOnlyentidadmuellaje,setReadOnlyEntidadMuellaje] = useState();
 
    const [primeraeje,setPrimeraEje]=useState(false);
    const [peticion_fallida,setPeticionFallida] = useState(false);
    /********************************************************************************/
    const ConsultarEntidad = async(e,nombreentidad,code=0,mostrar_cortinilla=true)=>{
            try {    
                if(code <=0){
                    return;
                }
                const keyCode = e.keyCode || e.which;
                //console.log('Letter pressed:',keyCode);
                if ((keyCode < 65 && keyCode > 90) || (keyCode < 97 && keyCode > 122)) {
                    return;
                }  
                if(nombreentidad.trim().length < 3 ){
                    return;
                } 
                if(mostrar_cortinilla){
                    setIsLoading(true); 
                }
                    const url = URL+SEARCHCOMPANY; 
                    const params = {
                        strName :nombreentidad.trim()
                    } 
                   // console.log(params);
                   // console.log(url);
                    const myHeaders = new Headers();
                    myHeaders.append("Content-Type",  'application/json'); 
                    const resultado = await fetchData(url, 'POST', myHeaders, params);  
                   // console.log(resultado);
                    if(resultado.code === 0){ 
                        if( code === 1 ){
                            setListaEntidades(resultado.rows); 
                        }else{
                           // console.log(resultado.rows);
                            setListaEntidadesMuellaje(resultado.rows); 
                        }
                        setIsLoading(false);
                    }else{
                        if(resultado.code < 0){  
                            if( code === 1 ){
                                setListaEntidades(resultado.rows); 
                            }else{
                                setListaEntidadesMuellaje(resultado.rows); 
                            }
                            Mensaje(resultado.msg,"error","top-center",4500); 
                        }
                        else if(resultado === "signal is aborted without reason"){
                            Mensaje("Se agoto el tiempo de espera de la petición.","warning","top-center",4500);    
                        }else{
                          //
                          if(resultado.status === 404){
                            Mensaje(`Servidor no encontrado.`,"error","top-center",4500);        
                          }else if(resultado === "Failed to fetch"){
                            Mensaje(`Petición al servidor fallida.`,"error","top-center",4500);    
                          }
                        } 
                        setIsLoading(false);
                      }
            }catch (error) {
                Mensaje("Error al hacer la solicitud, ERROR: "+error ,"error","top-center",3500);
            }
    }

    useEffect(()=>{
        LOG_TOKEN();
        ConsultarItinerarioBuques();
        ConsultarTipoDocumentos();
    },[]);

    const [strtok,setStrTok] = useState("");
    const LOG_TOKEN = async( mostrar_cortinilla=true)=>{
        try{
            if(mostrar_cortinilla){
                setIsLoading(true); 
            } 
                const url = URL_LOGIN_SUCURSALES; 
                const params =  {
                    "userName" : USER,
                    "password" : PSW
                }           
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
                
                const resultado =  await fetchData(url, 'POST' , myHeaders, params); 
                if(resultado.token !== "" && resultado.token !== undefined){ 
                    setStrTok(resultado.token);
                    /*/if(_intBillId>0 && _strRFC!=""){
                        ConsultarSucursales( _intBillId, _strRFC, getUserBillingIdentifier(), getUserFiscalIdentifier(),resultado.token); 
                    }*/
                    //setIsLoading(false); 
                }else{
                    if(resultado.code < 0){
                        Mensaje(resultado.msg,"error","top-center",5000);
                        setPeticionFallida(true); 
                    }
                    if(resultado === "signal is aborted without reason"){
                        Mensaje("Se agoto el tiempo de espera de la petición.","warning","top-center",4500);    
                    }else{
                      //
                      if(resultado.status === 404){
                        Mensaje(`Servidor no encontrado.`,"error","top-center",4500);        
                      }else if(resultado === "Failed to fetch"){
                        Mensaje(`Petición al servidor fallida.`,"error","top-center",4500);    
                      }
                    }   
                    setIsLoading(false); 
                }
        }catch (error) {
            Mensaje("Error al hacer la solicitud, ERROR: "+error.messaje ,"error","top-center");
        } 
    }

    const ConsultarSucursales = async(clientId, rfcClient, agentId, rfcAgent, _strtok, code, mostrar_cortinilla=true )=>{ 
        try{ 
            setIsLoading(true);
            ///setValidaEntidad("");
            const url = URL_CONSULTAR_SUCURSALES; 
            const params =  {
                "clientId" : clientId, //intBillId,//entidadid,
                "rfcClient" : rfcClient,//regfc, 
                "agentId" : agentId,//getUserBillingIdentifier(),
                "rfcAgent" : rfcAgent//getUserFiscalIdentifier(),
            }     
            const myHeaders = new Headers();
            if(_strtok !== ""){
                myHeaders.append("Content-Type", 'application/json');  
                myHeaders.append("Authorization", ('Bearer '+_strtok) );
              } 
           
            const resultado =  await fetchData(url, 'POST',myHeaders,params);  
            
            if(resultado.result){ 
               // console.log(resultado);
                if(code === 1){
                    if(resultado.address !== null){
                        setIntInvPBIPAddressId(0);
                        setPbipSucursales(resultado.address);
    
                        if(resultado.address.length === 1 ){
                            setIntInvPBIPAddressId(resultado.address[0].customerAddressId );
                            setStrInvPBIPZipCode(resultado.address[0].postalCode);
                            setValidaEntidadPBIP(" is-valid ");
                        }else{
                            setIntInvPBIPAddressId(0);
                            setStrInvPBIPZipCode("");
                            setValidaEntidadPBIP(" is-invalid ");
                        }

                    }else{
                        Mensaje(resultado.comment,"error","top-center",4500);
                        setValidaEntidadPBIP(" is-invalid ");
                        setIntInvPBIPAddressId(0);
                        setPbipSucursales([])
                    }
                }else{  
                    if(resultado.address !== null){    
                        setIntInvDockAddressId(0);
                        setMuellajeSucursales(resultado.address);
    
                        if(resultado.address.length===1 ){
                            setIntInvDockAddressId(resultado.address[0].customerAddressId );
                            setStrInvDockZipCode(resultado.address[0].postalCode);
                            setValidaEntidadMuellaje(" is-valid ");
                        }else{
                            setIntInvDockAddressId(0);
                            setStrInvDockZipCode("");
                            setValidaEntidadMuellaje(" is-invalid ");
                        }
                    }else{
                        Mensaje(resultado.comment,"error","top-center",4500);
                        setValidaEntidadMuellaje(" is-invalid ");
                        setIntInvDockAddressId(0);
                        setMuellajeSucursales([])
                    }
                }
                  
                setIsLoading(false); 
            }else{
                Mensaje(resultado.comment, "error","top-center",4000);
                if(code === 1){
                    setValidaEntidadPBIP(" is-invalid ");
                }else{
                    setValidaEntidadMuellaje(" is-invalid ");
                }

                setIsLoading(false); 
            } 
        }catch (error) {
            Mensaje("Error al hacer la solicitud, ERROR: "+error.messaje ,"error","top-center");
        } 
    } 

    const handleEntidad = (strrfc="DHI9710177Z2", intBillId=24, intCompanyId, nombreentidad="", code) => { 
        try{ 
            /*if(code === 1 ){
                limpiarPbip(); 
            }else{
                limpiarMuellaje();
            }*/

            if(strrfc==="" && intBillId === 0 && intCompanyId === 0 && nombreentidad === "asdsda"){
                return;
            } 
            if( strrfc.trim().length < 10 ){ 
                Mensaje('El RFC de la entidad no es valido por favor comuniquese con el area de Facturación.',"warning","top-center",4000 );
                return;
            }
            if(intBillId <= 0){ 
                Mensaje('El Billing de la entidad no es valido por favor comuniquese con el area de Facturación.',"warning","top-center",4000 );
                return;
            }
            if(intCompanyId <= 0){ 
                Mensaje('El identificador de la entidad no es valido por favor comuniquese con el area de Facturación.',"warning","top-center",4000 );
                return;
            } 
            let index = -1;
            if(code === 1){
                 index = listaentidades.findIndex(item =>  (item.strRFC === strrfc && item.intCompanyId === parseInt(intCompanyId)) );
            }else{
                 index = listaentidadesmuellaje.findIndex(item =>  (item.strRFC === strrfc && item.intCompanyId === parseInt(intCompanyId)) );
            }
            
            if(strrfc.trim() !== "" && index >= 0 && intBillId > 0){     
               
                if(strtok !== "" && strtok !== undefined){ 
                    if(code === 1 ){    
                        setEntidadPbipId(listaentidades[index].intCompanyEntityId);
                        setEntidadPbipTypeId(listaentidades[index].intCustomerType); 
                        setStrInvPBIPFiscalId(listaentidades[index].strRFC);
                        setNombreEntidadPbipId(nombreentidad);  
                        setReadOnlyEntidadPbipId(true);
                        ConsultarSucursales( listaentidades[index].intBillId, listaentidades[index].strRFC, getUserBillingIdentifier(), getUserFiscalIdentifier(),strtok, code); 
                       
                    }else{
                        setEntidadMuellajeId(listaentidadesmuellaje[index].intCompanyEntityId);
                        setEntidadMuellajeTypeId(listaentidadesmuellaje[index].intCustomerType);
                        
                        setNombreEntidadMuellaje(nombreentidad);
                        setStrInvDockFiscalId(listaentidadesmuellaje[index].strRFC); 
                        setReadOnlyEntidadMuellaje(true); 

                        ConsultarSucursales( listaentidadesmuellaje[index].intBillId, listaentidadesmuellaje[index].strRFC, getUserBillingIdentifier(), getUserFiscalIdentifier(),strtok, code); 
                    }
                }else{
                      Mensaje("no hay token para revisar sucursales","warning","top-center",5000)
                }   
                 
            }else{
                /*
                    setEntidadId(0);
                    setNombreEntidad(""); 
                    setValidaEntidad(" is-invalid ");
                    setReadOnlyEntidad(false);  
                    Mensaje('Datos de la entidad incompletos.',"warning","top-center",4000 );
                */
            }    
        }catch(err){
            Mensaje('Error:'+err,"error","top-center",4000 );
        } 
    }

    const limpiarMuellaje = () =>{
        setValidaEntidadMuellaje("");
        setNombreEntidadMuellaje(""); 

        setStrInvDockFiscalId("")
        setStrInvDockZipCode("");

        setIntInvDockAddressId(0); 
        setMuellajeSucursales([]);

        setListaEntidadesMuellaje([]);

        setEntidadMuellajeTypeId(0)
        setEntidadMuellajeId(0);
        setReadOnlyEntidadMuellaje(false);
    }

    const limpiarPbip = () =>{
        setValidaEntidadPBIP("");
        setNombreEntidadPbipId(""); 
        setEntidadPbipTypeId(0);
        
        setListaEntidades([]);

        setStrInvPBIPZipCode("");
        setStrInvPBIPFiscalId("");
        setIntInvPBIPAddressId(0);
        setPbipSucursales([]);

        setEntidadPbipId(0);
        setReadOnlyEntidadPbipId(false);
    }

    /******************************************************************************/
    const [lista_buques_calatus,setListaBuquesCalatus] = useState([]); 
    const [buque,setBuque] = useState("");//VesselVoyageId
    const [validabuque, setValidaBuque] =useState("");
    const [nombrebuque,setNombreBuque] = useState("");
    const [readOnly,setReadOnly] = useState();

    //    //const [conttab,setContTab]=useState();

    const handleBuqueCalatus = (buquecal,nombrebuque) => {
        setValidaBuque(" is-invalid ");
        setNombreBuque("");
        setBuque(0);
        setReadOnly(false); 
        if(parseInt(buquecal) > 0){
            const index = lista_buques_calatus.findIndex(item =>  item.intVesselVoyageId === parseInt(buquecal) );
            setBuque(lista_buques_calatus[index].intVesselVoyageId);
            setNombreBuque(nombrebuque);
            setValidaBuque(" is-valid ");
            setReadOnly(true); 
        }
    }

    const limpiar_controles =()=>{
        setValidaBuque("");
        setNombreBuque(""); 
        setBuque(0);
        setReadOnly(false);
    }

    const getFechaBuque =(strdate)=>{
        const date = new Date(strdate);
        const pad = (num) => {return (num < 10 ? '0' : '') + num};
        let formattedDate = "";
        if( date.getUTCFullYear() === 1900 ){
          formattedDate = "-";
        }else{
          formattedDate = `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;  
        }
        return formattedDate;
    }
    /************************************************************************/
    

    const ConsultarItinerarioBuques = async() => {
        try { 
            setIsLoading(true); 
                const url = URL+GETVESSELITINERARY; 
                const params = {
                    "intUserId":getUserID()
                }  
              
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
                const resultado =  await fetchData(url, 'POST', myHeaders, params); 
              
                if(resultado.code === 0){  
                    setListaBuquesCalatus(resultado.rows);
                    setIsLoading(false);       
                }else if(resultado.code > 0){
                    setPeticionFallida(true);
                    Mensaje(resultado.msg, "info", "top-center",3500);   
                }else if(resultado.code < 0){
                    setPeticionFallida(true);
                    Mensaje("No se encontraron buques.", "warnings", "top-center",3500); 
                } 
        }catch (error) {
            Mensaje("Error al hacer la solicitud, ERROR: "+error.message ,"error","top-center");
        }
    }
    
    const ConsultarTipoDocumentos = async() => {
        try { 
            setIsLoading(true);
            if(getUserID() > 0){
                const url = URL+GETDOCUMENTCATALOG; 
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
                const resultado =  await fetchData(url, 'GET'); 
                if(resultado.code === 0){
                    setListaTipoDocumento(resultado.rows);
                    setIsLoading(false); 
                }else if(resultado.code > 0){
                    setPeticionFallida(true);
                    Mensaje(resultado.msg, "info", "top-center", 3500); 
                    setIsLoading(false); 
                }else if(resultado.code < 0){
                    setPeticionFallida(true); 
                    Mensaje("No se encontraron resultado en el catalogo de documentos.", "warning", "top-center", 3500); 
                    setIsLoading(false); 
                }
            }else{
                window.location.assign('/inicio');
            }
        }catch (error) {
            setIsLoading(false);
            Mensaje("Error al hacer la solicitud, ERROR: "+error.message ,"error","top-center");
        }
    }

    const GuardarReferencia =async()=>{
        try { 
            setIsLoading(true); 
            let  validadoc = true;
            if(referencia.trim().length === 0  || referencia.trim().length > 45 ){
                setValidaReferencia(" is-invalid ");
                Mensaje( "Debe asignar un referencia de maximo 45 caracteres." ,"warning","top-center",5000);
                validadoc = false;
            } 

            if(buque > 0){
                setValidaBuque(" is-valid ");
            }else{
                setValidaBuque(" is-invalid ");
                Mensaje( "Debe asignar un buque." ,"warning","top-center",5000);
                validadoc = false;
            } 
                     //validaentidadpbip 
                    if( entidadpbipid > 0 && entidadpbiptypeid > 0){
                        setValidaEntidadPBIP(" is-valid ");
                    }else{
                        Mensaje( "Debe asignar una entidad para facturar PBIP o desmarcar la casilla." ,"warning","top-center",5000);
                        setValidaEntidadPBIP(" is-invalid ");
                        validadoc = false;
                    }
                    
                    if( strInvPBIPFiscalId !== "" ){
                        setValidaEntidadMuellaje(" is-valid ");
                    }else{
                        Mensaje( "Debe asignar el RFC de la entidad para facturar Pbip." ,"warning","top-center",5000);
                        setValidaEntidadMuellaje(" is-invalid ");
                        validadoc = false;
                    }

                                    
                    if( intInvPBIPAddressId > 0 ){
                        setValidaEntidadMuellaje(" is-valid ");
                    }else{
                        Mensaje( "Debe asignar una sucursal de la entidad para facturar Pbip." ,"warning","top-center",5000);
                        setValidaEntidadMuellaje(" is-invalid ");
                        validadoc = false;
                    }
     
                    //validaentidadpbip
                    //alert(entidadmuellajetypeid);
                    if( entidadmuellajeid > 0 && entidadmuellajetypeid > 0){
                        setValidaEntidadMuellaje(" is-valid ");
                    }else{
                        Mensaje( "Debe asignar una entidad para facturar muellaje." ,"warning","top-center",5000);
                        setValidaEntidadMuellaje(" is-invalid ");
                        validadoc = false;
                    }
 
                    if( strInvDockFiscalId !== "" ){
                        setValidaEntidadMuellaje(" is-valid ");
                    }else{
                        Mensaje( "Debe asignar el RFC de la entidad para facturar muellaje." ,"warning","top-center",5000);
                        setValidaEntidadMuellaje(" is-invalid ");
                        validadoc = false;
                    }

                    if( intInvDockAddressId > 0 ){
                        setValidaEntidadMuellaje(" is-valid ");
                    }else{
                        Mensaje( "Debe asignar una sucursal de la entidad para facturar muellaje." ,"warning","top-center",5000);
                        setValidaEntidadMuellaje(" is-invalid ");
                        validadoc = false;
                    }
              
            /*if(modo !== 'E'){
                if(pdfData.trim().length > 0 ){
                    setValidaArchivo("is-valid");
                }else{
                    setValidaArchivo("is-invalid");
                    validadoc = false;
                }
            }*/
             
            if(!validadoc){
                setIsLoading(false);
                return;
            }else{
                const dto = {   
                    "strUserName":getUserName(),
                    "intMode": modo === 'E'? 2:1,
                    "ref":{
                        "intCusDocId":referenciaid,
                        "strCusDocReference": referencia,
                        "intCusDocVesselVoyageId":buque, //ID BUQUE//
                         
                        "intCusDocEntityTypeId": getIntUserEntityTypeId(),    //DEL USUARIO USUARIO//
                        "intCusDocEntityId":     getintUserEntityId(),           //DEL USUARIO USUARIO//
                       
                        /**********************************************************************************************************************/
                        "intInvDockId": entidadmuellajeid > 0 && entidadmuellajetypeid > 0? entidadmuellajeid:0,//numeric,
                        "intInvDockTypeId": entidadmuellajetypeid > 0 && entidadmuellajeid > 0? entidadmuellajetypeid:0,//numeric,
                        
                        "intInvPBIPId": entidadpbipid > 0 && entidadpbiptypeid > 0 ? entidadpbipid : 0,//numeric,
                        "intInvPBIPTypeId": entidadpbiptypeid > 0 && entidadpbipid > 0? entidadpbiptypeid : 0,//numeric,

                        "intInvDockAddressId": intInvDockAddressId,//numeric,
                        "strInvDockFiscalId": strInvDockFiscalId,//varchar(15),
                        "strInvDockZipCode": strInvDockZipCode,//varchar(10), 
                        "intInvPBIPAddressId": intInvPBIPAddressId,//numeric,
                        "strInvPBIPFiscalId": strInvPBIPFiscalId,//varchar(15),
                        "strInvPBIPZipCode": strInvPBIPZipCode//varchar(10);
                    }
                }  
               // console.log("--->",dto)
                const url = URL+SAVEUPDATEREFERENCE; 
                var myHeaders = new Headers(); 
                myHeaders.append("Content-Type",  'application/json'); 
                const resultado =  await fetchData(url, 'POST', myHeaders, dto); 
               // console.log("--->",resultado)
                if(resultado.code >= 0){ 
                    if(resultado.ref !== undefined && resultado.ref.intCusDocId > 0){
                        if(resultado.code === 0 && resultado.ref.intCusDocId !== undefined ){ 
                            if(modo === "A"){
                                setReferenciaId(resultado.ref.intCusDocId); 
                            }
                            setEstatus(resultado.ref.strStatus.trim())
                            setIntCusDocStatusId(resultado.ref.intCusDocStatusId)
                            Mensaje(resultado.msg ,"success","top-center",5000);    
                            setModo('E');
                        }else{
                            Mensaje(resultado.msg ,"warning","top-center",5000);    
                        }
                        
                    }else{
                        Mensaje(resultado.msg, "error","top-center",5000);
                    }
                    //ConsultarDocumentosUsuario()
                    setIsLoading(false); 
                }if(resultado.code < 0){
                    Mensaje(resultado.msg+", "+resultado.errorText ,"error","top-center",5000); 
                    setIsLoading(false); 
                
                }else if(resultado.code > 0){
                    Mensaje(resultado.msg,"info","top-center",5000); 
                    setIsLoading(false); 
                }
            }
        }catch (error) {
            setIsLoading(false);
            Mensaje("Error al hacer la solicitud, ERROR: "+error.message ,"error","top-center");
        }
    } 

    const ConsultarReferenciaId = async()=>{
        try { 
            setIsLoading(true);
            setDocumentos([]); 
                const url = URL+GETREFERENCEBYID; 
                const params = {
                    "intUserId":getUserID(),
                    "intCusDocId": referenciaid
                }
                var myHeaders = new Headers(); 
                myHeaders.append("Content-Type",  'application/json');   
                const resultado =  await fetchData(url, 'POST', myHeaders, params); 
                if(resultado.code >= 0){ 
                   
                    setReferencia(resultado.ref.strCusDocReference);
                    setIntCusDocStatusId(resultado.ref.intCusDocStatusId);
                    setEstatus(resultado.ref.strStatus);
                    /*if(resultado.ref.intCusDocVesselVoyageId > 0){
                        const index = lista_buques_calatus.findIndex(item =>  item.intVesselVoyageId === parseInt(resultado.ref.intCusDocVesselVoyageId) );
                        setBuque(lista_buques_calatus[index].intVesselVoyageId);
                        setNombreBuque(lista_buques_calatus[index].strVesselName);
                        setReadOnly(true); 
                    }*/
                    try {
                        setBuque(resultado.ref.intCusDocVesselVoyageId);
                        setNombreBuque(resultado.ref.strVesselName);
                        setReadOnly(true);
                    } catch (error) {
                        
                    } 
                    //PBIP 
                    if(resultado.ref.intInvPBIPId === 0  && resultado.ref.intInvPBIPTypeId === 0 ){    
                        setIsCheckedPBIP(false);
                    }else{
                        setIsCheckedPBIP(true);
                        setEntidadPbipId(resultado.ref.intInvPBIPId);
                        setEntidadPbipTypeId(resultado.ref.intInvPBIPTypeId);
                        setNombreEntidadPbipId(resultado.ref.intInvPBIPTypeId +" - "+ resultado.ref.intInvPBIPId +" - "+ resultado.ref.strCusDocInvPBIPName);
                        //DECIRLE A ANA QUE AGREGE EL NOMBRE DE LA ENTIDDAD CON EL id 
                    } 
                    //MUELLAJE        &&   intCusDocEntityTypeId 
                    if(resultado.ref.intInvDockId === 0  && resultado.ref.intInvDockTypeId === 0 ){    
                        setIsCheckedMUELLAJE(false);
                    }else{
                        setIsCheckedMUELLAJE(true);
                        setEntidadMuellajeId(resultado.ref.intInvDockId);
                        setEntidadMuellajeTypeId( resultado.ref.intInvDockTypeId);
                        setNombreEntidadMuellaje(resultado.ref.intInvDockTypeId+" - "+resultado.ref.intInvDockId+" - "+resultado.ref.strCusDocInvDockName);
                        //DECIRLE A ANA QUE AGREGE EL NOMBRE DE LA ENTIDDAD CON EL id 

                        ///CODE = 1 - SUCURSALES
                        ///ConsultarSucursales( listaentidades[index].intBillId, listaentidades[index].strRFC, getUserBillingIdentifier(), getUserFiscalIdentifier(),strtok, code); 

                    } 


/***********************************************************************************************************/
                    if(resultado.ref.strInvDockFiscalId.trim() === "" ){    
                        setStrInvDockFiscalId("");
                    }else{
                        setStrInvDockFiscalId(resultado.ref.strInvDockFiscalId.trim());
                    } 

                    if(resultado.ref.strInvPBIPFiscalId.trim() === ""){    
                        setStrInvPBIPFiscalId("");
                    }else{
                        setStrInvPBIPFiscalId(resultado.ref.strInvPBIPFiscalId.trim());
                    } 
                     
                    if(resultado.ref.strInvDockZipCode.trim() === "" ){    
                        setStrInvDockZipCode("");
                    }else{
                        setStrInvDockZipCode(resultado.ref.strInvDockZipCode.trim());
                    } 
                    if(resultado.ref.strInvPBIPZipCode.trim() === "" ){    
                        setStrInvPBIPZipCode("");
                    }else{
                        setStrInvPBIPZipCode(resultado.ref.strInvPBIPZipCode.trim());
                    } 
                    
                    

                    if(parseInt(resultado.ref.intInvPBIPAddressId) === 0){    
                        setIntInvPBIPAddressId("");
                    }else{
                        setIntInvPBIPAddressId(resultado.ref.intInvPBIPAddressId);
                    } 

                    if(parseInt(resultado.ref.intInvDockAddressId) === 0){    
                        setIntInvDockAddressId("");
                    }else{
                        setIntInvDockAddressId(resultado.ref.intInvDockAddressId);
                    } 
                    //listaentidades[index].intBillId
                    ConsultarSucursales(  parseInt(resultado.ref.strInvPBIPBillId), resultado.ref.strInvPBIPRFC.trim() , getUserBillingIdentifier(), getUserFiscalIdentifier(),strtok, 1); 
                    ConsultarSucursales(  parseInt(resultado.ref.strInvDockBillId), resultado.ref.strInvDockRFC.trim() , getUserBillingIdentifier(), getUserFiscalIdentifier(),strtok, 2); 
/***********************************************************************************************************/
                    if(resultado.docs.length > 0){
                        resultado.docs.map((item, index)=>{
                            setDocumentos(prevDocumentos => [...prevDocumentos, item]);
                            //documentos.push(item);
                            setIsLoading(false);
                        }) 
                    }else{
                        setDocumentos([]);
                        setIsLoading(false);
                    }
                 
                    if(resultado.docs.length > 0 && resultado.docs.length !== undefined){
                        setTabIndex(resultado.docs.length) 
                    }else{
                        setTabIndex(0) 
                    } 

                }else{
                    Mensaje(resultado.msg, "warning"); 
                    setIsLoading(false); 
                }
        }catch (error) {
            Mensaje("Error al hacer la solicitud, ERROR: "+error.message ,"error","top-center");
            setIsLoading(false);
        }
    }
    const CerrarModal=()=>{
        if(agrgandodocumento){
          Mensaje("DEBE TERMINAR DE AGREGAR EL NUEVO DOCUMENTO O CANCELARLO.","error", "top-center", 3000)
          return;
        }else{
          closeModal();
        }
    }
   
    if( modo === 'E' && listatipodocumento.length >0 && lista_buques_calatus.length >0  && primeraeje === false){//&& referenciaid > 0 ){
        setPrimeraEje(true);
        ConsultarReferenciaId();
    }else if(peticion_fallida){
        CerrarModal();
    }
    
    const Agregar_Documento =()=>{
       try {
            let x = 0;    
            const nuevoObjeto = {
                "intDocumentId":0, 
                "strDocumentFolio": ("NUEVO "+(documentos.length)),
                "intDocumentTypeId": -1,
                "imgDocumentImageFile": ""
            }  
            setDocumentos(prevDocumentos => [...prevDocumentos, nuevoObjeto]);
            setAgregandoDocumentos(true);
            if(documentos.length > 0 && documentos.length !== undefined){
                setTabIndex(documentos.length) 
            }else{
                setTabIndex(0) 
            }
       } catch (error) {
        
       }
       
    }

    const Eliminar_Nuevo_Documento =()=>{
        try {
            let x = 0;    
            setDocumentos(prevDocumentos => [...prevDocumentos.filter((_, index) => index !== (documentos.length-1))]);
            setAgregandoDocumentos(false);
            SelectTab(0); 
        } catch (error) {
            SelectTab(documentos.length-1);
            setAgregandoDocumentos(false);   
        } 
    }
    const SelectTab = (index) =>{
        setTabIndex(index);
    }
    const HandleFolio = (intDocumentId, strfol) => {
        if(strfol.length <= 20 ){
            const index = documentos.findIndex(item => item.intDocumentId === parseInt(intDocumentId) );
            if(index >= 0){
                documentos[index].strDocumentFolio = strfol.toUpperCase();
                setDocumentos(documentos)
            }  
        }
    }

    const HandleTipoDocumento=(intDocumentId,intDocumentTypeId,value)=>{
        /*intDocumentTypeId,evt.target.value*/ 
        const index = documentos.findIndex(item => item.intDocumentId === intDocumentId) ;
        if(index >= 0){
            documentos[index].intDocumentTypeId = value;
            setDocumentos(documentos => documentos)
        }else{
            
        } 
        
    }

    const AgregarNuevaReferencia = () => {
        try {
            setReferenciaId(0);
            setDocumentos([]);
            setReferencia("");
            setValidaReferencia("");
            
            setBuque(0);
            setNombreBuque("");
            setValidaBuque("");
            setReadOnly(false);
            
            /*
            setEntidadMuellajeId(0);
            setEntidadMuellajeTypeId(0);
            setValidaEntidadMuellaje("");
            setNombreEntidadMuellaje("");
            setReadOnlyEntidadMuellaje(true);
            setIsCheckedMUELLAJE(false);
            */
            limpiarMuellaje();
            limpiarPbip();
            /*
            setEntidadPbipId(0);
            setEntidadPbipTypeId(0);
            setValidaEntidadPBIP("");
            setNombreEntidadPbipId("");
            setReadOnlyEntidadPbipId(false);
            setIsCheckedPBIP(false);
            */

            setModo("A");
            setPrimeraEje(true);
            setEstatus("");
            setIntCusDocStatusId(0);
            setAgregandoDocumentos(false);
        } catch (error) {
            Mensaje("Ocurrio un error al momento de intentar agregar una nueva referencia, ERROR:"+error.Message,"error","top-center",4500);
            closeModal();
        }
    }

    const EnviarReferencia=async()=>{
        try { 
            if(agrgandodocumento===true){
                Mensaje("Tiene un documento pendiente por subir.","warning","top-center",3500);
                return;
            }
            setIsLoading(true);
                const url = URL+SENDREFERENCE; 
                const params = {
                    "intUserId":getUserID(),
                    "intCusDocId": referenciaid
                }  
               
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
                const resultado =  await fetchData(url, 'POST', myHeaders, params); 
              
                if(resultado.code === 0){  
                    Mensaje(resultado.msg, "success","top-center",4500); 
                    setIntCusDocStatusId(resultado.rows.intCusDocStatusId)
                    setEstatus("CAP");
                }else{
                    Mensaje(resultado.msg, "error","top-center",4500);
                    setEstatus("");
                }
                setIsLoading(false);
        }catch (error) {
            Mensaje("Error al hacer la solicitud, ERROR: "+error.message ,"error","top-center");
        }
    }

    return(
        <>
        {isLoading?<Loader />:<></>} 
        <div className="container">
            <div className="row my-2">
                <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                    <div className="row ">
                        <label className="mx-0 px-0" htmlFor="ref">REFERENCIA:</label>
                        {
                            modo === 'E'?
                            <label id="ref" className={`form-control form-control-sm`} > {referencia} </label>
                            :<input id="ref" type="text" autoComplete={"off"} className={`form-control form-control-sm ${validareferencia}`} maxLength={45} value={referencia} onChange={(evt)=>{handleReferencia(evt.target.value)}} />
                        }
                    </div>
                </div> 
                <div className="col-lg-1 col-md-1 col-sm-0 col-xs-0"></div>

                <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                    <div className="row "> 
                        <div className={`col-11 p-0 m-0 ${validabuque}`} >
                            <DatalistInput 
                                placeholder="Seleccione un buque"
                                value={nombrebuque}
                                onSelect={(item) => { handleBuqueCalatus(item.id,item.value)} }
                                style={{border:"none"}}
                                label="BUQUE:"
                                showLabel={true}
                                items={ 
                                    lista_buques_calatus&&
                                    lista_buques_calatus.map((el)=>(
                                        {id: el.intVesselVoyageId , value: el.intVesselVoyageId+" - "+el.strVesselName + " - "+ getFechaBuque(el.dteVesselVoyageArrivalDate)}
                                    ))
                                }
                                labelProps={{
                                    className:"m-0 p-0",
                                }}
                                inputProps={{
                                    className:('form-control form-control-sm'+validabuque),
                                    readOnly: readOnly, 
                                }}
                                listboxProps={{ 
                                    className:(' listboxProps'),
                                }}
                            />
                        </div>
                        {intCusDocStatusId === 0 || estatus === "REJ"?
                        <div className="col-1 btn_borrar_item_lista mb-1 pb-1">
                            <button className="btn-close " title="BORRAR CONTENIDO" onClick={limpiar_controles}></button>
                        </div>:<></>}
                    </div> 
                </div> 
 
            </div>    
            <div className="row my-2">
                <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
                    <div className="row "> 
                        <div className={`col-11 p-0 m-0 ${validaentidadmuellaje}`} >
                            <DatalistInput 
                                placeholder="Seleccione muellaje"
                                value={nombreentidadmuellaje}  

                                onSelect={(item) => { handleEntidad(item.strRFC, item.intBillId, item.intCompanyId, item.value,2)} }
                                onKeyPress={(ev) => { ConsultarEntidad(ev, ev.target.value,2) }}

                                style={{border:"none"}}
                                label="FACTURAR MUELLAJE A:"
                                showLabel={true}
                                items={  
                                    
                                    listaentidadesmuellaje.map((el,index)=>( 
                                            {key:index ,strRFC: el.strRFC, intBillId: el.intBillId, intCompanyId: el.intCompanyId,
                                                value:
                                                    el.intCustomerType  === 1? "CLIENTE - " + el.strCompanyName  
                                                    :el.intCustomerType === 2? "CONSIGNATARIA - " + el.strCompanyName  
                                                    :el.intCustomerType === 3? "LINEA NAVIERA  - " + el.strCompanyName  
                                                    :el.intCustomerType === 4? "AGENCIA ADUANAL - " + el.strCompanyName 
                                                    :el.intCustomerType === 5? "TRANSPORTISTA - " + el.strCompanyName  
                                            :""}
                                        ))
                                
                                }
                                labelProps={{
                                    className:"m-0 p-0",
                                }} 
                                inputProps={{
                                    /*disabled:(!isCheckedMUELLAJE),*/
                                    className:('form-control form-control-sm '+validaentidadmuellaje),
                                    readOnly: readOnlyentidadmuellaje,
                                }}
                                listboxProps={{ 
                                    className:(' listboxProps'),
                                }}
                            />
                        </div>
                        {intCusDocStatusId === 0 || estatus === "REJ" ?
                        <div className="col-1 btn_borrar_item_lista mb-1 pb-1">
                            <button className="btn-close " title="BORRAR CONTENIDO" onClick={limpiarMuellaje}></button>
                        </div>:<></>}
                    </div>  
                </div>

                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 mx-1">
                    <div className="row "> 
                        <div className={`col-12 p-0 m-0 ${validaentidadmuellaje}`} >
                            <label className="m-0 p-0">RFC: </label>
                            <label className={`form-control form-control-sm ${validaentidadmuellaje}`}>{strInvDockFiscalId}</label>   
                              
                        </div> 
                    </div>  
                </div>
                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 mx-1">
                    <div className="row "> 
                        <div className={`col-12 p-0 m-0 `} >
                            <label className="m-0 p-0">CÓDIGO POSTAL: </label>
                            <label className={`form-control form-control-sm ${validaentidadmuellaje}`}>{strInvDockZipCode}</label>
                        </div> 
                    </div>  
                </div>

                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 mx-1">
                    <div className="row "> 
                        <div className={`col-12 p-0 m-0 ${validaentidadmuellaje}`} >
                            <label className="m-0 p-0">SUCURSAL: </label>

                            <select className={`form-select form-select-sm ${validaentidadmuellaje}`} onChange={(evt)=>{setIntInvDockAddressId(evt.target.value)} } value={intInvDockAddressId} name="slcsucursal" id="slcsucursal">
                                { muellaje_sucursales ?
                                    <>
                                        <option key="0" value="0">seleccione una sucursal... </option> 
                                        {muellaje_sucursales.map((item)=>(
                                            <option  key={item.customerAddressId} value={item.customerAddressId}> 
                                                {` ${item.postalCode} - ${item.estadoDesc} - ${item.countryDesc} `}
                                            </option>
                                            ))
                                        }
                                    </>
                                    :<option value="-1">No se encontraron sucursales.</option>
                                }
                            </select>  
                              
                        </div> 
                    </div>  
                </div>

            </div> 

            <div className="row my-2">
                <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 ">
                    <div className="row ">  
                        <div className={`col-11 p-0 m-0 ${validaentidadpbip}`  } >
                            <DatalistInput 
                                placeholder="Seleccione una entidad..."
                                value={nombreentidadpbipid}
                                onSelect={(item) => { handleEntidad(item.strrfc, item.intBillId, item.intCompanyId, item.value,1)} }
                                onKeyPress={(ev) => { ConsultarEntidad(ev, ev.target.value,1) }}

                                style={{border:"none"}}
                                label="FACTURAR PBIP A:"
                                showLabel={true}
                                items={  
                                        listaentidades.map((el,index)=>( 
                                            {key:index ,strrfc: el.strRFC, intBillId: el.intBillId, intCompanyId: el.intCompanyId,
                                                value:
                                                    el.intCustomerType  === 1? "CLIENTE - " + el.strCompanyName +" - "+ el.strRFC+" - "+ el.intBillId
                                                    :el.intCustomerType === 2? "CONSIGNATARIA - " + el.strCompanyName + el.strCompanyName +" - "+ el.strRFC+" - "+ el.intBillId
                                                    :el.intCustomerType === 3? "LINEA NAVIERA  - " + el.strCompanyName + el.strCompanyName +" - "+ el.strRFC+" - "+ el.intBillId
                                                    :el.intCustomerType === 4? "AGENCIA ADUANAL - " + el.strCompanyName + el.strCompanyName +" - "+ el.strRFC+" - "+ el.intBillId
                                                    :el.intCustomerType === 5? "TRANSPORTISTA - " + el.strCompanyName + el.strCompanyName +" - "+ el.strRFC+" - "+ el.intBillId
                                            :""}
                                        ))
                                }
                                labelProps={{
                                    className:"m-0 p-0",
                                }} 
                                inputProps={{
                                    /*disabled:(!isCheckedPBIP),*/
                                    className:('form-control form-control-sm'+validaentidadpbip),
                                    readOnly: readOnlyentidadpbipid,
                                }}
                                listboxProps={{ 
                                    className:(' listboxProps'),
                                }}
                            />
                        </div>
                        {intCusDocStatusId === 0 || estatus === "REJ"?
                        <div className="col-1 btn_borrar_item_lista mb-1 pb-1">
                            <button className="btn-close " title="BORRAR CONTENIDO" onClick={limpiarPbip}></button>
                        </div>:<></>}
                    </div>
                </div>

                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 mx-1">
                    <div className="row "> 
                        <div className={`col-12 p-0 m-0 `} >
                            <label className="m-0 p-0">RFC: </label>
                            <label className={`form-control form-control-sm ${validaentidadpbip}`}>{strInvPBIPFiscalId}</label>   
                        </div> 
                    </div>  
                </div>

                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 mx-1">
                    <div className="row "> 
                        <div className={`col-12 p-0 m-0 ${validaentidadmuellaje}`} >
                            <label className="m-0 p-0">CÓDIGO POSTAL: </label>
                            <label className={`form-control form-control-sm ${validaentidadpbip}`}>{strInvPBIPZipCode}</label>   
                              
                        </div> 
                    </div>  
                </div>

                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12 mx-1">
                    <div className="row "> 
                        <div className={`col-12 p-0 m-0 ${validaentidadmuellaje}`} >
                            <label className="m-0 p-0">SUCURSAL: </label>
                            <select className={`form-select form-select-sm ${validaentidadpbip}`} onChange={(evt)=>{setIntInvPBIPAddressId(evt.target.value)} } value={intInvPBIPAddressId} name="slcsucursal" id="slcsucursal">
                            { pbipi_sucursales ?
                                <>
                                    <option key="0" value="0">seleccione una sucursal... </option> 
                                    {pbipi_sucursales.map((item)=>(
                                        <option  key={item.customerAddressId} value={item.customerAddressId}> {` ${item.postalCode} - ${item.estadoDesc} - ${item.countryDesc} `} </option>
                                    ))
                                    }
                                </>
                                :<option value="-1">No se encontraron sucursales.</option>
                            }
                            </select>  
                        </div> 
                    </div>  
                </div>
            </div>



            {intCusDocStatusId === 0 || estatus === "REJ"?
                <div className="row my-1"> 
                        <div className="">
                            <button className="btn btn-primary  btn-sm float-end" onClick={GuardarReferencia}> {modo === 'A'? "GENERAR REFERENCIA":"ACTUALIZAR REFERENCIA"}</button> 
                        </div> 
                </div>
                :<></>
            }
            
            {referenciaid > 0?
            
            <>  
            <hr className="my-1" />
                {intCusDocStatusId === 0 || estatus === "REJ" ?
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12 ">
                            <button className="btn btn-primary btn-sm" disabled={agrgandodocumento} onClick={Agregar_Documento}>AGEGAR DOCUMENTO</button>
                        </div>
                    </div> 
                    :<></>
                } 
                {documentos.length>=0  &&   documentos !== undefined?
                /*<Tabs selectedIndex={typeof(tabIndex) === 'undefined'? 0:tabIndex} onSelect={(index) => {setTabIndex(index)}}>*/
                /*<Tabs defaultIndex={0} >*/
                <Tabs  selectedIndex={tabIndex>=0? tabIndex:0} onSelect={(index) => { index>=0? setTabIndex(index):setTabIndex(0)}}> 
                    <TabList>
                        { 
                            documentos.map((item,index)=>(
                                <Tab key={index}> {/*"Tab"+item.referenciaid}> */}

                                {item.intDocumentId > 0? 
                                    <span className={"fw-bold "} >{item.strDocumentFolio} </span> :
                                    <span className={"fw-bold text-danger"} >{item.strDocumentFolio}
                                    {
                                        item.intDocumentId <=0? 
                                            <button className="btn-close mx-2" onClick={Eliminar_Nuevo_Documento} title="CANCELAR ARCHIVO"></button>:<></>
                                    }
                                    </span> 
                                }
                                    
                                </Tab>
                            ))
                        }
                    </TabList>
                    {
                        documentos.map((item,index)=>(
                            <TabPanel forceRenderTabPanel={true} key={"panel"+item.text}> 
                                {    
                                    <>
                                        <File idreferencia={referenciaid} AgregarNuevaReferencia={AgregarNuevaReferencia} estado={estatus} estatus={estatus} setAgregandoDocumentos={setAgregandoDocumentos} intCusDocStatusId={intCusDocStatusId} documentos={item} strreferencia={strreferencia} HandleFolio={HandleFolio} Mensaje={Mensaje} setTabIndex={setTabIndex} HandleTipoDocumento={HandleTipoDocumento} listatipodocumento={listatipodocumento} setIsLoading={setIsLoading} ConsultarReferenciaId={ConsultarReferenciaId}   />
                                    </>
                                }
                            </TabPanel>    
                        ))
                    } 
                </Tabs>:<></>
                }

                <div className="modal-footer m-0 p-0"> 
                    <div>
                    <div className="float-end">
                    {referenciaid > 0 && documentos.length > 0 && documentos[0].intDocumentId> 0 && intCusDocStatusId === 0 || estatus === "REJ"?
                        <button className="btn btn-sm text-bg-warning m-1 fw-bold float-end" onClick={()=>{EnviarReferencia()}}>ENVIAR REFERENCIA</button>
                        :<></>
                    }   
                    { intCusDocStatusId !== 0 || estatus === "CAP"?
                        <>
                            <button className="btn btn-sm text-bg-secondary m-1 fw-bold float-end" onClick={CerrarModal}>CERRAR</button>
                            <button className="btn btn-sm text-bg-primary m-1 fw-bold float-start" onClick={()=>{AgregarNuevaReferencia()}}>GENERAR NUEVA REFERENCIA</button>
                        </>
                        :<></>
                    }
                        

                    </div>
                    </div>
                </div>
                
            </>:<></>
            }
            {/* 
                <button className="btn btn-sm bg-secondary m-1 fw-bold" onClick={closeModal}>CERRAR</button>
                <button className="btn btn-sm text-bg-primary m-1 fw-bold float-start" onClick={()=>{AgregarNuevaReferencia()}}>GENERAR NUEVA REFERENCIA</button>
            */}
        </div>
        </>

    );
}

const File = ({idreferencia, AgregarNuevaReferencia, setAgregandoDocumentos, estado, documentos, strreferencia, intCusDocStatusId, HandleFolio, Mensaje, HandleTipoDocumento, listatipodocumento, setIsLoading, ConsultarReferenciaId })=>{ //, GuardarDocumento, EliminarDocumento})=>{  
    const [validafolio,setValidaFolio] = useState("");
    const [validatipodocumento,setValidaTipoDocumento] = useState("");
    const [validaarchivo,setValidaArchivo] = useState("");
    
    /**************************************************************************/    
    const [isOpenVerPfd, OpenVerPfd, closeVerPfd] = useModal(false);
    const [msgfile, setMsgFile] =useState("");
    const [pdfData, setPdfData] = useState("");
         
    const [pdfname, setPdfName] = useState("");
    const [pdfformat, setPdfFormat] = useState("");
    const [pdfsize, setPdfSize] = useState("");
        
    const handleFileChanges = (event, idreferencia, referenciaid) => {
            try{
            setPdfData("");
            //documentos.imgDocumentImageFile = "";
            //setPdfFormat("");
            setPdfSize("");
            setMsgFile("");
            setPdfName("");
            setValidaArchivo("");

            if(event.target.files[0].type === "" || event.target.files[0].type === undefined ){
                Mensaje( "El Formato del archivo debe ser PDF y pesar máximo 5MB." ,"warning","top-center",5000);    
                setMsgFile("El Formato del archivo debe ser PDF y pesar máximo 5MB.");
                return;
            }     

            if(event.target.files[0].type !== "application/pdf"){ 
                setValidaArchivo("is-invalid"); 
                setMsgFile("El Formato del archivo debe ser PDF.");//+event.target.files[0].type);
                event.target.value = null;
                return;
            }
        
            //alert("Tamaño:"+(event.target.files[0].size/1024)/1024)
            if( ((event.target.files[0].size/1024)/1024) > 5){ 
                setValidaArchivo("is-invalid");
                setMsgFile("El tamaño del archivo debe tener maximo 5 MB.")//no es valido, tamaño: "+event.target.files[0].size);
                event.target.value = null;
                return;
            }
       
            setValidaArchivo("is-valid");
            setPdfFormat(event.target.files[0].type);
            setPdfSize(event.target.files[0].size);
            setPdfName(event.target.files[0].name);
            //setFolio(event.target.files[0].name);
            const file = event.target.files[0];
            //console.log(file);
            if (file) {
              const reader = new FileReader();
              reader.onload = (e) => {
                const pdfBytes = btoa(new Uint8Array(e.target.result).reduce((data, byte) => data + String.fromCharCode(byte), ''));
                //console.log(pdfBytes);
                setPdfData(pdfBytes);
                const text =  event.target.files[0].name; //"PDF DE PRUEBA.pdf";
                const myArray = text.split(".");
                documentos.strDocumentFolio = myArray[0];
                setPdfName(myArray[0]);
                documentos.imgDocumentImageFile = pdfBytes;
                setX(!x);
                if(referenciaid > 0){
                    ActualizarDocumento(idreferencia, referenciaid);
                }

              };
              reader.readAsArrayBuffer(file);
            }
        }catch(err){
            documentos.imgDocumentImageFile="";
            setValidaArchivo(" is-invalid ");
        } 
    };
    
    const VerPDF = () => {
            OpenVerPfd();
    }

    const GuardarDocumento =async(idreferencia, referenciaid, strDocumentFolio, intDocumentTypeId, imgDocumentImageFile )=>{
        try { 
            setIsLoading(true); 
            let  validadoc = true;
            /*if(referencia.trim().length === 0  || referencia.trim().length > 45 ){
                setValidaReferencia(" is-invalid ");
                Mensaje( "Debe asignar un folio de maximo 45 caracteres." ,"warning","top-center",5000);
                validadoc = false;
            } */
            
            if( strDocumentFolio.length > 0 && strDocumentFolio.length <= 45 ){
                setValidaFolio(" is-valid ");
            }else{
                setValidaFolio(" is-invalid ");
                validadoc = false;
            }
            
            if( parseInt(intDocumentTypeId) > 0  ){
                setValidaTipoDocumento(" is-valid ");
            }else{
                setValidaTipoDocumento(" is-invalid ");
                validadoc = false;
            }

            if( documentos.imgDocumentImageFile !== ""  ){
                setValidaArchivo(" is-valid ");
            }else{
                setValidaArchivo(" is-invalid ");
                validadoc = false;
            }

            if(!validadoc){
                setIsLoading(false);
                Mensaje("Debe llenar todos los campos.","error","top-center",5000);
                return;
            }else{
                const dto = {
                    "intMode":referenciaid>0? 2:1,
                    "strUserName":getUserName(),
                    "doc":{
                        "intCusDocId":idreferencia,
                        "referenciaid":referenciaid,
                        "intDocumentTypeId":parseInt(intDocumentTypeId),
                        "strDocumentFolio": strDocumentFolio,
                        "imgDocumentImageFile": imgDocumentImageFile
                    }
                }
                
                //console.log("--->",dto)
                const url = URL+SAVEUPDATEDOCUMENT; 
                
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
                const resultado =  await fetchData(url, 'POST', myHeaders, dto); 
              
                
                if(resultado.code === 0){ 
                    if(documentos.referenciaid === 0 ){
                        documentos.imgDocumentImageFile = resultado.rows.referenciaid;
                        Mensaje(resultado.rows[0].msg ,"success","top-center",5000);
                        setAgregandoDocumentos(false);
                        ConsultarReferenciaId(); 
                    }else{
                        if(resultado.code === 0){
                            if(resultado.code === 0 && resultado.rows !== undefined ){
                                Mensaje(resultado.rows[0].msg ,"success","top-center",5000);    
                                //modo='E';
                                documentos.referenciaid = resultado.rows[0].referenciaid;
                                ConsultarReferenciaId();
                            }else{
                                Mensaje(resultado.msg ,"warning","top-center",5000);
                                setIsLoading(false);     
                            }
                            //ConsultarDocumentosUsuario()
                        }else{
                            Mensaje(resultado.msg, "error","top-center",5000);
                            setIsLoading(false); 
                        }
                        setAgregandoDocumentos(false);    
                    }
                    
                }else{
                    Mensaje(resultado.msg, "info","top-center",5000); 
                    setIsLoading(false); 
                    setAgregandoDocumentos(false);
                }
                 
            }
        }catch (error) {
            setIsLoading(false);
            Mensaje("Error al hacer la solicitud, ERROR: "+error.message ,"error","top-center");
        }
    } 
 
    const EliminarDocumento =async(referenciaid, intDocumentId )=>{
        try { 
            setIsLoading(true); 
            let  validadoc = true;
            /*if(referencia.trim().length === 0  || referencia.trim().length > 45 ){
                setValidaReferencia(" is-invalid ");
                Mensaje( "Debe asignar un folio de maximo 45 caracteres." ,"warning","top-center",5000);
                validadoc = false;
            } */
            //alert(intDocumentId);
            if( referenciaid <= 0  ){
                Mensaje( "El documento no esta ligado a ninguna referencia." ,"warning","top-center",5000);
                validadoc = false;
            }

            if(!validadoc){
                setIsLoading(false);
                return;
            }else{
                const dto = {
                    "intMode":3,
                    "strUserName":getUserName(),
                    "doc":{
                        "intCusDocId":referenciaid,
                        "intDocumentId":intDocumentId  
                    }
                }
                
                //console.log("--->",dto)
                const url = URL+SAVEUPDATEDOCUMENT; 
              
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
                const resultado =  await fetchData(url, 'POST', myHeaders, dto); 
              
                
                if(resultado.code === 0){ 
                    Mensaje(resultado.msg ,"warning","top-center",5000);
                    ConsultarReferenciaId();
                    
                }else{
                    Mensaje(resultado.msg, "info","top-center",5000); 
                }
                setIsLoading(false); 
            }
        }catch (error) {
            setIsLoading(false);
            Mensaje("Error al hacer la solicitud, ERROR: "+error.message ,"error","top-center");
        }
    }  

    const ActualizarDocumento = async(idreferencia, referenciaid )=>{
        try { 
            setIsLoading(true); 
            let  validadoc = true;
            
            if( documentos.imgDocumentImageFile === "" || documentos.imgDocumentImageFile === undefined ){
                setValidaArchivo(" is-invalid ");
                validadoc = false;
            }else{
                setValidaArchivo(" is-valid ");
            }

            if(!validadoc){
                setIsLoading(false);
                return;
            }else{
                const dto = {
                    "intMode": 4,
                    "strUserName": getUserName(), 
                    "doc":{
                        "intCusDocId":idreferencia,
                        "referenciaid": referenciaid,
                        "imgDocumentImageFile": documentos.imgDocumentImageFile
                    }  
                } 
                const url = URL+SAVEUPDATEDOCUMENT; 
                
                const myHeaders = new Headers();
                myHeaders.append("Content-Type",  'application/json'); 
                const resultado =  await fetchData(url, 'POST', myHeaders, dto); 
              
                if(resultado.code === 0){  
                    ConsultarReferenciaId();                       
                    Mensaje(resultado.msg, "success","top-center",5000);
                    setIsLoading(false);     
                }else{
                    Mensaje(resultado.msg, "error","top-center",5000); 
                    setIsLoading(false); 
                }
            }
        }catch (error) {
            setIsLoading(false);
            Mensaje("Error al hacer la solicitud, ERROR: "+error.message ,"error","top-center");
        }
    } 

    const [x,setX]=useState(false);
    const HandleTipodeDocumento= (intDocumentId,intDocumentTypeId,value) =>{
        HandleTipoDocumento(intDocumentId,intDocumentTypeId, value);
        setX(!x);
    } 

    const HandledeFolio = (intDocumentId,value) =>{
        HandleFolio(intDocumentId,value);
        setX(!x);
    }

    return(
        <div className="container"> 
            {/*<label className="fs-5">{`REFERENCIA ID:  ${idreferencia} - ID: ${documentos.intDocumentId} `}</label>*/}
            
            <div className="row">
                <div className="col-12">
                            <div className="row"> 
                                <div className="col-10 ">
                                    <label className="" htmlFor="pdffile">DOCUMENTO:</label>
                                    {intCusDocStatusId === 0 || estado === "REJ"? 
                                        <input id="pdffile" type="file" className={`form-control form-control-sm ${validaarchivo}`} style={{display:"none"}} accept='application/pdf' onChange={(evt)=>{handleFileChanges(evt, idreferencia, documentos.referenciaid)}} />
                                        :<></>
                                    }
                                    <label htmlFor="pdffile" className={`form-control form-control-sm ${validaarchivo}`} > 
                                        {/*<Iconos  cLass='bi flex-shrink-0 me-2' icono={"PDF"}  width={"35"} height={"35"} fill="#F00"/>*/}
                                        {
                                            documentos.imgDocumentImageFile !== ""?
                                            <span className="text-success fw-bold">ARCHIVO CARGADO</span>
                                            :<span className="text-danger fw-bold">SIN ARCHIVO CARGADO</span>
                                        } 
                                    </label>

                                </div>
                                <div className="col-1 m-0 p-0 btn_borrar_item_lista">
                                    { documentos.imgDocumentImageFile &&
                                        <button className="btn gb-secondary" onClick={VerPDF}> 
                                            <Iconos icono={"CONSULTAR"}  width={"25"} height={"25"} fill="#488955"/>
                                        </button>
                                    }
                                </div>
                                    {/*<p className="text-danger p-0">{pdfformat} - { pdfname  } - { ((pdfsize/1024)/1024) + "MB" }</p>*/}
                                    { msgfile && 
                                        <p className="text-danger  ">
                                            {msgfile}
                                        </p>
                                    } 
                            </div> 
                            <div className="row ">
                                <div className="col-10 ">
                                <div className="alert alert-info d-flex align-items-center p-1 my-1" role="alert"> 
                                    <Iconos cLass='bi flex-shrink-0 me-2' icono={"INFO"}  width={"25"} height={"25"} fill="#055160"/> 
                                    <div>
                                        <span className=" p-1">El PDF DEBE SER EDITABLE.</span>
                                    </div>
                                </div>
                                </div>
                            </div>
                           
                        <div className="row"> {/*folio*/} 
                            <div className="col-5">
                                <label htmlFor="">FOLIO:</label>
                                {intCusDocStatusId === 0 || estado === "REJ"? 
                                <input type="text" className={`form-control form-control-sm ${validafolio}}`} value={documentos.strDocumentFolio} onChange={(evt)=>{HandledeFolio(documentos.intDocumentId,evt.target.value)}} maxLength={20} minLength={2}/>
                                :<label className={`form-control }`} >{documentos.strDocumentFolio}</label> }
                            </div>
                            <div className="col-5">{/*tipo documento*/}
                                <label htmlFor="">TIPO DE DOCUMENTO:</label>
                                {intCusDocStatusId === 0 || estado === "REJ"? 
                                    <select name="" id="" value={documentos.intDocumentTypeId} className={`form-select form-select-sm ${validatipodocumento}`} onChange={(evt)=>{HandleTipodeDocumento(documentos.intDocumentId,documentos.intDocumentTypeId, evt.target.value)} }>
                                        <option value={-1}>Seleccione un tipo de documento</option>
                                        {listatipodocumento.map((item)=>(
                                            <option key={"op"+item.intDocumentTypeId} value={item.intDocumentTypeId}>{item.intDocumentTypeId +" - "+ item.strDocumentTypeDescription}</option>
                                        ))}
                                    </select>
                                    :<select value={documentos.intDocumentTypeId} disabled={true} className={`form-select   `} >
                                        <option value={-1}>Seleccione un tipo de documento</option>
                                        {listatipodocumento.map((item)=>(
                                            <option key={"op"+item.intDocumentTypeId} value={item.intDocumentTypeId}>{item.intDocumentTypeId +" - "+ item.strDocumentTypeDescription}</option>
                                        ))}
                                    </select>
                                }
                                
                            </div>
                        </div>
                          
                            { isOpenVerPfd &&
                                <div id="modal-resultados-validacion">
                                    {
                                    //<Modal titulo={"DOCUMENTO PDF : "+pdfname+ " - "+ ((pdfsize/1024)/1024).toFixed(2)+" MB"} isOpen={isOpenVerPfd}  closeModal={closeVerPfd}  Height={'90vh'} Width={'70vw'}   >
                                    }
                                    <Modal titulo={`MOSTRAR REFERENCIA: ${strreferencia} `} isOpen={isOpenVerPfd}  closeModal={closeVerPfd}  height={'90vh'} width={'99vw'} >      
                                        <MostrarPdf    
                                            referenciaid={idreferencia} 
                                            Mensaje={Mensaje}
                                            pdfData={documentos.imgDocumentImageFile}
                                            preview={200}
                                            intmode={777}
                                            mimetype={"application/pdf"}
                                            setIsLoading={ setIsLoading }
                                            isOpenMostrarPdf={isOpenVerPfd}
                                            OpenMostrarPdf={OpenVerPfd}  
                                            closeMostrarPdf={closeVerPfd}
                                        />  
                                    </Modal>
                                </div>
                            }
                </div>
                {/*<div className="col-5 border">
                </div>*/}
            </div>
            {
                intCusDocStatusId===0 || estado === "REJ"?
                <div className="row"> {/*botones*/} 
                    <div className="my-2">
                        <button className="btn btn-sm btn-primary m-1 float-end" onClick={()=>{GuardarDocumento(idreferencia,documentos.intDocumentId, documentos.strDocumentFolio, documentos.intDocumentTypeId, documentos.imgDocumentImageFile)}}>GUARDAR DOCUMENTO</button>
                        {documentos.intDocumentId >0? <button className="btn btn-sm btn-danger  m-1 float-end"  onClick={()=>{EliminarDocumento(idreferencia,documentos.intDocumentId)}}>ELIMINAR DOCUMENTO</button>:<></>}
                    </div> 
                </div> 
                :<></>
            }
            
        </div>
    )
}
  
export default UploadFile;